module.exports = __webpack_public_path__ + "static/media/Terren_Headshot.7d43f0be.png";